import { render, staticRenderFns } from "./SensorList.vue?vue&type=template&id=0080237b&scoped=true"
import script from "./SensorList.vue?vue&type=script&lang=js"
export * from "./SensorList.vue?vue&type=script&lang=js"
import style0 from "./SensorList.vue?vue&type=style&index=0&id=0080237b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080237b",
  null
  
)

export default component.exports